
class AnError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message; // Dunno, Error doesn't seem to store this

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }

  fullDetails () {
    return JSON.stringify(this, null, 2);
  }
}

export class ConfigurationError extends AnError {}

export class JsonParseError extends AnError {

  /**
   * @param {Response} response 
   * @param {string} body 
   */
  constructor (response, body) {
    const { url, status, headers } = response;
    super(`Request to ${url} responded ${headers.get('content-type')}`);
    this.url = url;
    this.status = status;
    this.body = body;
  }
}

export class DataLoadFailure extends AnError {

  /**
   * @param {Response} response 
   * @param {{ message: string  }} data 
   */
  constructor(response, data) {
    const { url, status } = response;
    super(`${data.message ? data.message + ' ' : ''}for '${url}'`);
    this.statusCode = status;
    this.data = data;
    this.failedUrl = url;
  }
}

export class FetchRejected extends AnError {
  constructor(error) {
    super(error.toString());
  }
}

export class InvalidAPIKeyError extends AnError {
  constructor () {
    super('Invalid API key given in the request');
  }
}

export class InvalidHashError extends AnError {
  constructor(hash) {
    super(`hash '${hash}' doesn't exists`);
  }
}

export class DisabledError extends AnError {
  constructor(hash) {
    super(`hash '${hash}' is disabled`);
  }
}

export class ViewStateError extends AnError {
  constructor(state, error) {
    super(error.toString());
    this.state = state;
  }
}
